import { render, staticRenderFns } from "./CopasstDocumentos.vue?vue&type=template&id=04237eee&"
import script from "./CopasstDocumentos.vue?vue&type=script&lang=js&"
export * from "./CopasstDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports